import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState, RealEstateObject } from '@immosky/types';
import { clamp } from '@immosky/shared';
import { selectMapResults } from '../../state/results/map-results/map-results.selectors';

@Component({
  selector: 'app-map-cards',
  templateUrl: './map-cards.component.html',
  styleUrls: ['./map-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MapCardsComponent implements OnInit {
  private readonly slideGap = 12;

  objects: RealEstateObject[] = [];
  slideIndex = 0;

  get translateX(): string {
    const gap = this.slideIndex * this.slideGap;
    return `translateX(calc(-${this.slideIndex * 100}% - ${gap}px))`;
  }

  get isPreviousButtonDisabled(): boolean {
    return this.slideIndex === 0;
  }

  get isNextButtonDisabled(): boolean {
    return this.slideIndex >= this.objects.length - 1;
  }

  constructor(
    private cdRef: ChangeDetectorRef,
    private store: Store<AppState>
  ) {}

  ngOnInit(): void {
    this.store
      .pipe(select(selectMapResults))
      .subscribe((mapObjects: RealEstateObject[]) => {
        this.objects = mapObjects;
        this.goToSlide(0);
        this.cdRef.markForCheck();
      });
  }

  previous() {
    this.goToSlide(this.slideIndex - 1);
  }

  next() {
    this.goToSlide(this.slideIndex + 1);
  }

  goToSlide(index: number) {
    this.slideIndex = clamp(0, index, this.objects.length - 1);
  }

  trackBy(index: number, object: RealEstateObject) {
    return object.id;
  }
}
